export const tr = {
    'icon-title': 'Öneriler',
    'popup-title': 'Öneriler'
};
